import { createTheme, colors } from "@material-ui/core";
const darktheme = createTheme({
  typography: {
    body1: {
      fontFamily: '"Poppins",Roboto,Helvetica,Arial',
    },
  },

  overrides: {
    // MuiCssBaseline: {
    //   "@global": {
    //     "@font-face": ["Poppins", "Roboto", "Helvetica", "Arial"],
    //   },
    // },
  },

  UpdateTheme: {
    button_color: "#1b1b1b",
    text_color: "#fff",
    heading_color: "#1b1b1b",
    theme_color: "#1b1b1b",
    link_color: "#4e4e4e !important",
    table_head_color: "#1b1b1b",
  },

  palette: {
    background: {
      dark: "transparent",
      default: "#4e4e4e !important",
      paper: "#4e4e4e !important",
      dmode: "transparent",
      even: "transparent",
    },
    header: {
      bg: "black",
      text: "white",
    },
    leftBar: {
      bg: "black",
      text: "white",
      active: "white",
    },
    primary: {
      main: "#4e4e4e !important",
    },
    secondary: {
      main: "#4e4e4e !important",
    },
    text: {
      primary: colors.common.white,
      secondary: colors.common.white,      
      border: "#333",
      primary2: colors.blueGrey[600],
    },
    button: {
      borderRadius: "20px",
      color: "white",
      // background: "black !important",
      background: "#FFC62D",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "white",
      },
    },
    buttonSecondary: {
      borderRadius: "20px",
      color: "white",
      background: "black",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "white",
      },
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          "@font-face": ["Poppins", "Roboto", "Helvetica", "Arial"],
        },
      },
      MuiButton: {
        root: {
          color: "red", // Example button color
        },
      },
      // Add overrides for other Material-UI components here
    },
  },
  borders: {
    custombbottom: "10px solid transparent",
    assesbbottom: "2px solid #fff",
  },
});
export default darktheme;
